var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{attrs:{"gutter":60}},[_c('el-col',{staticClass:"d-none d-md-block",attrs:{"md":24}},[_vm._t("left"),_c('ib-divider',{staticClass:"my-3",attrs:{"block":""}})],2),_c('el-col',{attrs:{"md":12}},[_c('div',{staticClass:"d-flex justify-content-end",class:!_vm.rightEnd ? 'justify-content-md-start' : null},[_vm._t("right")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }